<div class="backtesting-div">
    <section id="backtesting" class="backtesting section-padding">
        <div class="container">
            <div class="section-title text-center">
                <h2 class="wow fadeInUp" data-wow-delay=".2s">Backtesting</h2>
                <h3 class="wow fadeInUp" data-wow-delay=".3s">Feasibility Analysis 27% Annualised Return</h3>
            </div>
            <div class="row align-items-center">
                <div class="col-md-7 textBox">
                    <div class="wow fadeInLeft" data-wow-delay=".4s">
                    <p>This summary page presents an outline of the approach Cosmic Algorithm Ltd (CAL) undertook when developing the Backseat-Trader algorithm.</p>
                    <p>The chart on the right is a comparison between the algorithm's historical equity curve versus the value of SPY, QQQ, and SPY-AGG 70/30 portfolio equity curves. All systems are rebalanced monthly with US$10,000 initial investment. There is no capital reinvestment assumed.</p>
                    <p>CAL can supply the back-testing data used in electronic format, upon request.</p>
                    <div class="infoText">
                        <p>A momentum-based semi-automated stock rotation system. Only long positions are traded. The system tracks NASDAQ index components on a daily basis and selects the top 20 best performing stocks of the index. The selection is rebalanced once per month which increases return and reduces volatility</p>
                    </div>
                    </div>

                </div>
                <div class="col-md-5 imgBox">
                    <div class="wow fadeInRight" data-wow-delay=".5s">
                        <img class="img-fluid" src="assets/img/graph.jpg" alt="Backseat-Trader" style="width: 100%;" alt="">
                    </div>
                </div>
            </div>
            
            

            <div class="textBox mt-5">
                <h3 class="wow fadeInUp" data-wow-delay=".2s">CAL does summarily list the analytical methodologies for this algorithm:</h3>
                <div class="row align-items-center">
                    <div class="col-md-12 textBox">
                        <ol class="gradient-list">
                            <li class="wow fadeInLeft" data-wow-delay=".4s">Runs on daily candles</li>
                            <li class="wow fadeInRight" data-wow-delay=".4s">Absolute momentum quantification mechanism based on 13612 weighted filter</li>
                            <li class="wow fadeInLeft" data-wow-delay=".5s">Relative momentum ranking and weight allocation system</li>
                            <li class="wow fadeInRight" data-wow-delay=".5s">Support for stock and ETF portfolios</li>
                            <li class="wow fadeInLeft" data-wow-delay=".6s">Support for leveraged and unleveraged accounts</li>
                            <li class="wow fadeInRight" data-wow-delay=".6s">Adjustable rebalance period</li>
                        </ol>
                    </div>
                    
                </div>
            </div>

            <div class="textBox mt-5">
                <div class="analytical_list">
                    <!--  -->
                </div>
                <div class="singInfo row align-items-center mt-4 wow fadeInUp" data-wow-delay=".2s">
                    <div class="col-sm-auto ml-auto">
                        <p><i>Report prepared by Nikita Gurbin – Algorithmic Developer</i></p>
                        <div class="row">
                            <div class="col-sm-auto">
                                <p>Kind regards, John Donnelly<br>
                                    Director, Cosmic Algorithm Limited</p>
                            </div>
                            <div class="col-sm-auto"><img class="img-fluid" src="assets/img/signature.png" height="40" alt="Algorithmic Developer"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <section class="section_wrapper cta_wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="note wow fadeInUp" data-wow-delay=".2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <ul>
                            <li><h3>Get started with US$500</h3></li>
                            <!-- <li><p></p></li> -->
                            <li><a href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term=" target="_blank" class="btn theme-btn hoverclr animate JoinusoneToro4">Join us on eToro</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>